export const consecusiveReqDelay = 60 * 1000
export const OOB_CODE_REFRESH_TIME = 60
export const REFRESH_STATUS_DEFAULT = 'refresh'
export const REFRESH_STATUS_DISABLED = 'disabled'
export const REFRESH_STATUS_LOADING = 'loading'
export const REFRESH_TYPE_KEY = 'TYPE_NFT'
